export const REQUEST_DATE_FORMAT = 'YYYY-MM-DD';
export const US_SHORT_DATE_FORMAT = 'MM/DD/YY';
export const US_MEDICAL_DATE_FORMAT = 'MM/DD/YYYY';
export const US_MEDICAL_TIME_FORMAT = 'HH:mm';
export const US_MEDICAL_DATE_TIME_FORMAT = `${US_MEDICAL_DATE_FORMAT} ${US_MEDICAL_TIME_FORMAT}`;
